<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>

<!-- Full-screen map wrapper container -->
<div class="map-page-wrapper">

  <!-- Left Sidebar Panel for Controls & List -->
  <div class="sidebar-panel">
    <div class="panel-header">
      <img src="../../../assets/img/truck_icon_green.svg" class="header-icon" alt="Truck" />
      <h5>Vehicle Telematics</h5>
    </div>

    <!-- Search Input Fields -->
    <div class="search-section d-flex align-items-center" style="gap: 10px;">
      <mat-form-field class="full-width-field density-compact mb-0" style="flex: 1;">
        <mat-label>Search Truck</mat-label>
        <input
          matInput
          [(ngModel)]="truckNo"
          (keyup)="onInputKeyUp($event)"
          (change)="onInputPickUpchange()"
          (input)="onTruckNumberChange($event)"
          #pickUpLocationSearchField
          type="text"
        />
      </mat-form-field>

      <div class="d-flex align-items-center">
        <button
            *ngIf="search_btn"
            type="button"
            class="action-btn search-btn-active"
            [disabled]="isSearchButtonDisabled"
            (click)="!isSearchButtonDisabled ? searchTruckTrackInfo(truckNo, true) : null"
          >
            <img src="../../../assets/img/search-white.svg" alt="Search" />
          </button>
          <button
            *ngIf="clear_btn"
            type="button"
            class="action-btn clear-btn-active"
            (click)="resetTruckTrackInfo()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
              <path d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
            </svg>
          </button>
      </div>
    </div>

    <!-- Active Trucks List -->
    <div class="trucks-list-section">
      <div class="list-summary">
        Available Trucks: <strong>{{ trackArray?.length }}</strong>
      </div>
      <div class="list-container">
        <div
          class="truck-list-item"
          *ngFor="let items of trackArray; let i = index"
          [ngClass]="{
            selected: isSelectedTruck === (items.truck_location_history?.vehicleNumber || items.truckNumber)
          }"
          (click)="selectTruck(items, false)"
        >
          <span class="index">{{ i + 1 }}.</span>
          <span class="vno">{{ items.truck_location_history?.vehicleNumber || items.truckNumber }}</span>
          <span class="status-dot" [ngClass]="getDotClass(items)"></span>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Map Area -->
  <div class="map-area">
    <div id="map-container"></div>

    <!-- Loading spinner over the map -->
    <div class="map-loader-overlay" *ngIf="isLoading">
      <div class="circle-dot-loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>

    <!-- Floating Status Bar Overlay -->
    <div class="floating-status" *ngIf="statusText">
      <span class="status-icon-dot"></span>
      <span class="status-message">{{ statusText }}</span>
    </div>

    <!-- Floating Route Visibility Toggle -->
    <!-- <button
      id="toggle-route"
      *ngIf="isRouteLoaded"
      [ngClass]="{ 'hidden-route': !routeVisible }"
      (click)="toggleRouteVisibility()"
    >
      <span class="dot"></span>
      {{ routeVisible ? 'Hide route' : 'Show route' }}
    </button> -->
  </div>
</div>

<!-- Details Dialog Modal -->
<form action="">
  <div class="modal" id="myModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" *ngIf="truckStatus">
          <h4 class="modal-title trip">
            {{ arrayMarker?.truckStatus?.toUpperCase() }}
          </h4>
          <button type="button" class="close" (click)="closeModel()" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-header" *ngIf="truckOfflineStatus">
          <h4 class="modal-title trip">
            {{ statusOffline }}
          </h4>
          <button type="button" class="close" (click)="closeModel()" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-header" *ngIf="intransit">
          <h4 class="modal-title trip">ON-TRIP</h4>
          <button type="button" class="close" (click)="closeModel()" data-dismiss="modal">&times;</button>
        </div>
        
        <div class="modal-body name">
          <div class="row">
            <div class="col-sm-6">
              <b>Vehicle Number:</b>
              <div>{{ arrayMarker?.truckNumber }}</div>
            </div>
            <div class="col-sm-6">
              <b>Driver Name:</b>
              <div>{{ arrayMarker?.driverName }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <b>Trip Id:</b>
              <div>{{ arrayMarker?.trip_id }} - {{ arrayMarker?.tripStatus }}</div>
            </div>
            <div class="col-sm-6">
              <b>Mobile Number:</b>
              <div>{{ arrayMarker?.driverNumber }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <b>Start Date:</b>
              <div>{{ arrayMarker?.pickUpdate | date : "dd-MM-yyyy" }}</div>
            </div>
            <div class="col-sm-6">
              <b>Last Updated:</b> 
              <div>{{ arrayMarker?.updateTime | date : "dd-MM-yyyy, hh:mm a" }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <b>Latitude:</b>
              <div>{{ arrayMarker?.location?.lat }}</div>
            </div>
            <div class="col-sm-6">
              <b>Longitude:</b>
              <div>{{ arrayMarker?.location?.lng }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b>Location:</b>
              <div>{{ arrayMarker?.address }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
